import { ChangeBankAccountAttribute } from './ChangeBankAccountAttribute'

export default ChangeBankAccountAttribute
